// Bootstrap. Login is REQUIRED: this entry point mounts ONLY the auth gate. The rest of the app
// (./app — the chart, panels, ops, everything that sets window.seabearing) is dynamically imported
// and mounted only once a session exists, so an unauthenticated visitor genuinely cannot use it.
import './style.css';
import { AuthGate } from './ui/authGate';
import { captureFriendLink } from './social/friendLink';

// Build + mount the whole app exactly once. The dynamic import's module-eval side effects do the
// mounting; importing again just returns the settled module.
let appPromise: Promise<unknown> | null = null;
function mountApp(): Promise<void> {
  if (!appPromise) appPromise = import('./app');
  return appPromise.then(() => undefined);
}

// A friend link (…/?friend=<token>) is lifted into localStorage BEFORE the login wall, so it survives
// sign-in — including a magic-link / OAuth round trip, which returns without the query string.
captureFriendLink();

const gate = new AuthGate(mountApp);
document.body.append(gate.root);
